function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.125977 1.03223C0.125977 0.699544 0.212565 0.444336 0.385742 0.266602C0.558919 0.0888672 0.80957 0 1.1377 0C1.47038 0 1.72331 0.0934245 1.89648 0.280273C2.06966 0.462565 2.15625 0.713216 2.15625 1.03223C2.15625 1.35579 2.06738 1.61328 1.88965 1.80469C1.71647 1.99154 1.46582 2.08496 1.1377 2.08496C0.80957 2.08496 0.558919 1.99154 0.385742 1.80469C0.212565 1.61784 0.125977 1.36035 0.125977 1.03223Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.98145 1.03223C3.98145 0.699544 4.06803 0.444336 4.24121 0.266602C4.41439 0.0888672 4.66504 0 4.99316 0C5.32585 0 5.57878 0.0934245 5.75195 0.280273C5.92513 0.462565 6.01172 0.713216 6.01172 1.03223C6.01172 1.35579 5.92285 1.61328 5.74512 1.80469C5.57194 1.99154 5.32129 2.08496 4.99316 2.08496C4.66504 2.08496 4.41439 1.99154 4.24121 1.80469C4.06803 1.61784 3.98145 1.36035 3.98145 1.03223Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.83691 1.03223C7.83691 0.699544 7.9235 0.444336 8.09668 0.266602C8.26986 0.0888672 8.52051 0 8.84863 0C9.18132 0 9.43425 0.0934245 9.60742 0.280273C9.7806 0.462565 9.86719 0.713216 9.86719 1.03223C9.86719 1.35579 9.77832 1.61328 9.60059 1.80469C9.42741 1.99154 9.17676 2.08496 8.84863 2.08496C8.52051 2.08496 8.26986 1.99154 8.09668 1.80469C7.9235 1.61784 7.83691 1.36035 7.83691 1.03223Z",
  fill: "current"
});

function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 3,
    viewBox: "0 0 10 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.e1e4c3f4.svg";
export { ForwardRef as ReactComponent };